import { IResponseState } from "../../../../components/Modals/ResponseModal/module/constants";

import {
  STATE_IDENTIFIER,
  LIST_IDENTIFIER,
  LOADER_IDENTIFIER,
} from "./constants";

const {
  STEP_ONE,
  STEP_TWO,
  STEP_THREE,
  MANUALS_SECTIONS_TABLE,
  SECTION_DETAIL,
  ATTACHMENTS,
  ATTACHMENT,
  ATTACHMENT_ROLES,
  SELECTED_ROLES,
  ADDED_ROLES,
  REMOVED_ROLES,
  REQUEST_STATE,
  ROLES,
  TOTAL_ROLES,
} = STATE_IDENTIFIER;

export default {
  [STEP_ONE]: {
    [MANUALS_SECTIONS_TABLE]: {
      [LIST_IDENTIFIER]: [],
      [LOADER_IDENTIFIER]: false,
    },
  },
  [STEP_TWO]: {
    [SECTION_DETAIL]: {
      [LIST_IDENTIFIER]: [],
      [ATTACHMENTS]: [],
      [LOADER_IDENTIFIER]: false,
    },
    [REQUEST_STATE]: IResponseState.PENDING,
  },
  [STEP_THREE]: {
    [ATTACHMENT]: {
      [LIST_IDENTIFIER]: [],
      [ATTACHMENT_ROLES]: [],
      [LOADER_IDENTIFIER]: false,
    },
    [SELECTED_ROLES]: [],
    [ROLES]: {
      [LIST_IDENTIFIER]: [],
      [LOADER_IDENTIFIER]: false,
    },
    [ADDED_ROLES]: [],
    [REMOVED_ROLES]: [],
    [TOTAL_ROLES]: [],
    [REQUEST_STATE]: IResponseState.PENDING,
  },
  [REQUEST_STATE]: IResponseState.PENDING,
};
